import { Component, ErrorHandler, OnInit } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IAppError } from "@comunicare/comunicare-interfaces";
import { environment } from "../environments/environment";
import { FileLogger } from "./core/error-handling/fileLogger";
import { GlobalErrorHandler } from "./core/error-handling/global-error-handler";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private globalErrorHandler: ErrorHandler,
    private snackBar: MatSnackBar,
    public matIconRegistry: MatIconRegistry
  ) {
    matIconRegistry.registerFontClassAlias("solid", "fas");
  }

  ngOnInit(): void {
    // Listen global error
    (this.globalErrorHandler as GlobalErrorHandler).catchedError.subscribe((error: IAppError) => {
      // also console error to get source only in not production env
      if (!environment.production) {
        FileLogger.error("AppComponent", "globalErrorHandler in ngOnInit", error, "none");
        console.trace();
      }
      this.snackBar.open(error.message, "ok", {
        duration: 10000,
      });
    });
  }
}
